// extracted by mini-css-extract-plugin
export default {"pAlert":"FormShipment_pAlert__9yPHg","pAlertt":"FormShipment_pAlertt__y73AC","status":"FormShipment_status__zblX0","minWidth80":"FormShipment_minWidth80__BQ2-A"};